import React from 'react';
import {
  MultiStepFormContainer,
  PreviousStep,
  StepWrapper,
} from './MultiStepLayout.styled';
import Icon from '@components/atoms/Icon/Icon';
import PropTypes from 'prop-types';

const MultiStepLayout = ({ children, currentStep, handlePrevStep }) => {
  return (
    <>
      <MultiStepFormContainer>
        <PreviousStep onClick={handlePrevStep} type='button'>
          {currentStep !== 1 && (
            <>
              <Icon name='arrow' variant={'left'} />
              <p style={{ marginLeft: '0.75rem', lineHeight: 1 }}>Retour</p>
            </>
          )}
          {currentStep === 1 && <div style={{ height: '40px' }} />}
        </PreviousStep>
        <StepWrapper>{children}</StepWrapper>
      </MultiStepFormContainer>
    </>
  );
};

MultiStepLayout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
  handlePrevStep: PropTypes.func.isRequired,
};

export default MultiStepLayout;
